import { APISecret } from "./APIs";
import { CopyToClipboard } from "../../CopyToClipboard";
import { TextButton } from 'cdk-radial'

export const AppDetailsContainer = ({
  apiKey,
  apiSecret,
  keyIssueDate,
  onGenerateNewSecret,
  isGeneratingSecretDisabled,
}) => {
  return (
    <section className="api-details-container">
      <div className="container-heading">Credentials</div>
      <div className="container-text">
        <div className="row">
          <div className="key">API Key</div>
          <div className="value">
            {apiKey && (
              <>
                <div>{apiKey}</div>
                <CopyToClipboard textToCopy={apiKey} size={24} />
              </>
            )}
          </div>
        </div>
        <div className="row">
          <div className="key">API Secret</div>
          {apiSecret && (
            <div className="value">
              <APISecret secret={apiSecret} />
              <CopyToClipboard textToCopy={apiSecret} size={24} />
              <TextButton
                data-testid="generate-new-secret"
                text="Generate New Secret"
                onClick={onGenerateNewSecret}
                isDisabled={isGeneratingSecretDisabled}
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="key">Key Issue Date</div>
          <div className="value">{keyIssueDate}</div>
        </div>
      </div>
    </section>
  );
};